import PageWrapper from "../../Components/PageWrapper";
import { Text, View } from "@react-pdf/renderer";
import { formatCurrency } from "../../Utils/formatCurrency";
import CfmReportStyles from "../../CfmReportStyles";

const columns = [
  { key: "age", label: "Age" },
  { key: "fundValue", label: "Fund Value" },
  { key: "contribution", label: "Contribution" },
  { key: "regularWithdrawals", label: "Regular Withdrawals" },
  { key: "adhocInvestment", label: "Ad-Hoc Contribution" },
  { key: "adhocWithdrawals", label: "Ad-Hoc Withdrawal" },
];

const CHUNK_SIZE = 18;

const InvestmentResultsSection = ({
  investmentResults,
  details,
  primaryColor,
  tradingName,
  footerText,
}) => {
  if (!investmentResults?.length) return null;

  const styles = CfmReportStyles(primaryColor);

  return (
    <>
      {investmentResults.map((entry, idx) => {
        const funds = entry.investmentFunds || [];

        // determine active columns
        const activeColumns = columns.filter((col) => {
          if (col.key === "age") return true;
          return funds.some((fund) => fund[col.key] !== "£0.00");
        });

          const personIndex = investmentResults
            .slice(0, idx)
            .filter((e) => e.name === entry.name).length;
          const displayIndex = personIndex + 1;

          const omittedColumns = columns
            .filter((col) => !activeColumns.includes(col))
            .map((col) => col.label);

          // console.log(
          //   `InvestmentResultsSection - columns omitted for ${entry.name}:`,
          //   omittedColumns.length ? omittedColumns.join(", ") : "None"
          // );

          // split to page chunks
          const chunks = [];
          const matchedPerson = details.find((p) => p.name === entry.name);
          const retirementAge = Number(matchedPerson?.retirementAge);

          for (let i = 0; i < funds.length; i += CHUNK_SIZE) {
            chunks.push(funds.slice(i, i + CHUNK_SIZE));
          }

          return chunks.map((chunk, chunkIndex) => (
            <PageWrapper
              key={`${entry.name}-${chunkIndex}`}
              size="A4"
              style={styles.page}
              orientation="landscape"
              primaryColor={primaryColor}
              tradingName={tradingName}
              headerTitle={
                chunkIndex === 0
                  ? `${entry.name} - Investment ${displayIndex}: Growth Overview`
                  : `${entry.name} - Investment ${displayIndex}: Growth Overview (continued)`
              }
              headerSubText={`${entry.type}`}
              footerText={footerText}
            >
              <View style={{ padding: 16 }}>
                <View style={styles.tableWrapper}>
                  <View style={styles.tableHeader}>
                    {activeColumns.map((col) => (
                      <Text
                        key={col.key}
                        style={[
                          styles.tableCell,
                          styles.tableHeaderText,
                          col.key === "age" && styles.ageCell,
                        ]}
                      >
                        {col.label}
                      </Text>
                    ))}
                  </View>

                  {chunk.map((fund, i) => {
                    const isRetirementAge = Number(fund.age) === retirementAge;
                    const isAltRow = i % 2 !== 0;

                    return (
                      <View
                        key={i}
                        style={[
                          styles.tableRow,
                          isAltRow && styles.altRow,
                          isRetirementAge && styles.highlightRow,
                        ]}
                      >
                        {activeColumns.map((col) => (
                          <Text
                            key={col.key}
                            style={[
                              styles.tableCell,
                              col.key === "age" && styles.ageCell,
                            ]}
                          >
                            {col.key === "age"
                              ? fund[col.key]
                              : formatCurrency(fund[col.key])}
                          </Text>
                        ))}
                      </View>
                    );
                  })}
                </View>
              </View>
            </PageWrapper>
          ));
      })}
    </>
  );
};

export default InvestmentResultsSection;
